import React, { type FC } from 'react';

export const SignalDiscountSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.52276 2.52272C2.18804 2.85741 2 3.31134 2 3.78466V7.45631C2.0001 7.9296 2.18821 8.38346 2.52295 8.71807L7.2824 13.4772C7.44814 13.6429 7.64491 13.7744 7.86147 13.8641C8.07803 13.9538 8.31014 14 8.54455 14C8.77896 14 9.01107 13.9538 9.22764 13.8641C9.4442 13.7744 9.64096 13.6429 9.8067 13.4772L13.4774 9.80553C13.812 9.47085 14 9.017 14 8.54377C14 8.07054 13.812 7.61669 13.4774 7.28201L8.71798 2.52291C8.38349 2.18834 7.92983 2.00026 7.45672 2H3.7848C3.31144 2 2.85747 2.18803 2.52276 2.52272ZM5.5 7C6.32843 7 7 6.32843 7 5.5C7 4.67157 6.32843 4 5.5 4C4.67157 4 4 4.67157 4 5.5C4 6.32843 4.67157 7 5.5 7Z"
                fill="#F05537"
            />
        </svg>
    );
};
